<template>
  <dyte-meeting :ref="meetingId" />
</template>

<script>
//import DyteClient from "@dytesdk/web-core";
export default {
  name: "Display_Sessions_MySessions",
  components: {},
  props: {
    resource: {
      type: Object,
      required: () => {
        return {};
      }
    },
    settings: {
      type: Object,
      required: () => {
        return {};
      }
    },
    session: {
      type: Object,
      default: () => {
        return {};
      },
      required: true
    }
  },
  created() {},
  mounted() {
    this.setUpMeeting();
  },
  setUpMeeting() {
    const searchParams = new URLSearchParams(window.location.search);
    const authToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9"; //searchParams.get("authToken");
    const roomName = searchParams.get("roomName") || "";

    if (!authToken) {
      alert(
        "An authToken wasn't passed, please pass an authToken in the URL query to join a meeting."
      );
      return;
    }

    DyteClient.init({
      authToken,
      roomName
    }).then(meeting => {
      if (
        this.$refs[this.meetingId] &&
        this.$refs[this.meetingId].hasOwnProperty("value") &&
        this.$refs[this.meetingId].value.hasOwnProperty("meeting")
      ) {
        this.$refs[this.meetingId].value.meeting = meeting;
      }
    });
  },
  computed: {},
  methods: {},
  data() {
    return {
      meetingId: "meeting-id",
      clientId: "bf79d19b-b0de-41f4-878a-b89e69430cfa"
    };
  }
};
</script>
